import { Directive, ElementRef, HostListener, Input } from '@angular/core';

import { ScrollButtonListDirective } from './scroll-button-list.directive';

@Directive({
    selector: '[appScrollArrow]',
    standalone: true
})
export class ScrollButtonArrowDirective {
  constructor(
    private elRef: ElementRef,
    private menu: ScrollButtonListDirective,
  ) {}

  @Input() appScrollArrow: 'next' | 'prev';

  @HostListener('click')
  onClick(): void {
    if(this.appScrollArrow === 'next') {
      this.menu.onNext();
    }
    else if(this.appScrollArrow === 'prev') {
      this.menu.onPrev();
    }
  }
}
